// WhiteBoxForm.jsx
import React from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Swal from 'sweetalert2';
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import axios from "axios";

const WhiteBoxForm = ({ children }) => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const spin_gacha = (value) => {
        const apikey = Cookies.get('apikey');
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get('hustmediavipro');
        if (!apikey) {
            alert_error('Bạn chưa login')
            return
        } else if (!code_item || !hustmediavipro) {
            alert_error('Ko tìm thấy status của bạn')
            return
        }
        else {
            // setnutorder('đặt tiếp luôn nào')
            Swal.fire({
                title: 'Thông báo',
                text: 'Quay gacha lại jop với phí 5 Coins free',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Từ chối',
            }).then((result) => {
                console.log(result);
                // If user agrees, set agreed to true
                if (result.isConfirmed) {
                    console.log('đồng ý');
                    // setnutxuly(1);
                    // setnutorder('Please wait a moment 😊');
                    gacha_process();
                } else {
                }
            });
        }
    };
    const spin_lists = (value) => {
        const apikey = Cookies.get('apikey');
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get('hustmediavipro');
        if (!apikey) {
            alert_error('Bạn chưa login')
            return
        } else if (!code_item || !hustmediavipro) {
            alert_error('Ko tìm thấy status của bạn')
            return
        }
        else {
            // setnutorder('đặt tiếp luôn nào')
            Swal.fire({
                title: 'Thông báo',
                text: 'Tải lại danh sách jop với phí 5 Coins free',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Từ chối',
            }).then((result) => {
                console.log(result);
                // If user agrees, set agreed to true
                if (result.isConfirmed) {
                    console.log('đồng ý');
                    // setnutxuly(1);
                    // setnutorder('Please wait a moment 😊');
                    lists_process();
                } else {
                }
            });
        }
    };
    function gacha_done(info) {
        if (info.status == 0) {
            alert_error(info.message);
            switch_router('/reactapp/reload_page');
        }
        else if (info.status == 1) {
            alert_success(info.message);
            switch_router('/reactapp/reload_page');
        }
        else {
            switch_router('/reactapp/reload_page');
        }
    }
    function gacha_process() {
        // setnutxuly(0);
        const apikey = Cookies.get('apikey');
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get('hustmediavipro');
        alert_success('Đang quay gacha');
        // setnutxuly(1);
        // setnutorder('Please wait a moment 😊');
        axios.get('https://hust.media/link/load_logic/remix_gacha_update.php', {
            params: {
                apikey: apikey,
                code_item: code_item,
                lienket: hustmediavipro
            }
        })
            .then(response => (gacha_done(response.data)))
            .catch(error => (alert_error(error)))
    };
    function lists_process() {
        // setnutxuly(0);
        const apikey = Cookies.get('apikey');
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get('hustmediavipro');
        alert_success('Đang quay gacha');
        // setnutxuly(1);
        // setnutorder('Please wait a moment 😊');
        axios.get('https://hust.media/link/load_logic/remix_lists_update.php', {
            params: {
                apikey: apikey,
                code_item: code_item,
                lienket: hustmediavipro
            }
        })
            .then(response => (gacha_done(response.data)))
            .catch(error => (alert_error(error)))
    };
    return (
        <div>
            <div className="form-control">
                <div className="flex flex-col justify-center items-center text-center mt-0">
                    {children}
                    <div className="flex space-x-4">
                        <div className="flex text-base text-gray-800 items-center">
                            <div
                                className="button bg-pink-300 text-white py-0 px-1 rounded cursor-pointer"
                                onClick={() => switch_router("/reactapp/reload_page")}
                            >
                                reload page
                            </div>
                            <div
                                className="text-green-600 text-lg cursor-help"
                                data-tooltip-id="tooltip-service"
                                data-tooltip-html="✨ Nhận lại job mới,<br> trong cùng nội dung hiện tại,<br> nếu có lỗi! 💖🎉"
                            >
                                <div className="mx-2 bg-green-100 rounded-full w-5 h-5 flex items-center justify-center">
                                    <span className="text-green-600 text-lg font-semibold select-none">
                                        ?
                                    </span>
                                </div>
                            </div>
                            {/* Tooltip với className để override style */}
                            <Tooltip
                                id="tooltip-service"
                                className="!text-lg !p-3 !rounded-lg"
                                place="top"   // tuỳ chọn vị trí
                                effect="solid" // tuỳ chọn hiệu ứng
                            />
                        </div>

                        <div className="flex text-base text-gray-800 items-center">
                            <div
                                className="button bg-pink-300 text-white py-0 px-1 rounded cursor-pointer"
                                onClick={() => spin_lists()}
                            >
                                reload lists
                            </div>
                            <div
                                className="text-green-600 text-lg cursor-help mr-2"
                                data-tooltip-id="tooltip-gacha"
                                data-tooltip-html="🔄 Nếu nội dung hiện tại lỗi,<br>chuyển cái khác làm nha! 😊✨"
                            >
                                <div className="mx-2 bg-green-100 rounded-full w-5 h-5 flex items-center justify-center">
                                    <span className="text-green-600 text-lg font-semibold select-none">
                                        ?
                                    </span>
                                </div>
                            </div>
                            <Tooltip
                                id="tooltip-gacha"
                                className="!text-lg !p-3 !rounded-lg"
                                place="top"
                                effect="solid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhiteBoxForm;
